/// *** System import ***///
import { Injectable, Inject } from '@angular/core';
import { Events, ToastController } from 'ionic-angular';
import { hubConnection } from 'signalr-no-jquery';
import { RESOURCE_CACHE_PROVIDER } from '@angular/platform-browser-dynamic';
/// *** Custom import ***///
import { Globals } from '../../app/globals';
import { EnvVariables } from '../../app/environment-variables/environment-variables.token';

@Injectable()
export class TradingHubProvider {
  constructor(
    // *** System
    private events: Events,
    private toastCtrl: ToastController,
    // *** Custom
    private globals: Globals,
    @Inject(EnvVariables) private envVariables) {
  }

  // *** Hub subscription
  public subscribe(userID: string) {
    return new Promise((resolve, reject) => {
      try {
        // Init
        let connection = hubConnection(this.envVariables.mainPushEndpoint);
        connection.logging = false;
        let proxy = connection.createHubProxy('webtradingOrder');
        // Subscriptions
        proxy.on('refresh', this._onRefresh(this));
        // Start
        connection.start()
          .done(function () {
            proxy.invoke('subscribe', userID);
          })
          .fail(function () {
            connection.stop();
            setTimeout((provider = this) => {
              this.events.publish('TradingHubProvider.reconnect', userID);
            }, 5000);
          });
        // Keep alive
        connection.disconnected(function () {
        });
        // On try reconnect
        this.events.subscribe('TradingHubProvider.reconnect',
          (userID) => {
            connection.stop();
            setTimeout((provider = this) => {
              provider.subscribe(userID);
            }, 5000);
          });
        // Abord connection
        this.events.subscribe('TradingHubProvider.abord', () => { connection.stop(); });
        // On session user logout
        this.events.subscribe('SessionProvider.logout', () => { connection.stop(); });
        resolve();
      }
      catch (error) {
        this.globals.showCommunicationError(this.toastCtrl, error);
        reject();
      }
    });
  }

  // *** 'refresh' handler
  private _onRefresh(provider: TradingHubProvider): { (tradingOrderID: any, isCollective: any): void } {
    return function (tradingOrderID: any, isCollective: any) {
      provider.events.publish('TradingHubProvider.refresh');
    }
  }
}


// WEBPACK FOOTER //
// ./src/providers/serverHubs/trading.ts